<template>
  <div class="container">
    <div class="dots">
      <div />
      <div />
      <div />
    </div>
  </div>
</template>
<script>
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  display: flex;
}

.dots div {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #0085FF;
  animation: bounce 1s ease infinite;
  transform: scale(0);
  &:nth-child(2) {
    animation-delay: -0.15s;
  }
  &:nth-child(3) {
    animation-delay: -0.3s;
  }
  &:not(:first-child) {
    margin-left: 10px;
  }
}

@keyframes bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
</style>
